<style scoped>
    .confirm-message {
        text-align: center;
    }
</style>

<template>
    <v-dialog v-model="handleDialog" width="1000" class="common-dialog">
        <v-card color="#F4FEFB">
            <v-card-title class="text-h4 justify-left">{{ item.billing_month.slice(0, 4) }} / {{ item.billing_month.slice(4, 6) }}　内訳</v-card-title>
                <v-card-text
                    class="common-dialog-message5"
                >
                <v-container>
                    <v-row>
                        <v-row cols="12" xl="12">
                            <v-col cols="2"></v-col>
                            <v-col cols="5">
                                <p class="text--primary">{{ item.plan_name }}</p>
                            </v-col>
                            <v-col cols="3">
                                <p class="text--primary text-right">{{ item.plan_amount.toLocaleString() }}円</p>
                            </v-col>
                            <v-col cols="1"></v-col>

                            <v-col cols="2"></v-col>
                            <v-col cols="3">
                                <p class="text--primary">送信件数</p>
                            </v-col>
                            <v-col cols="2"></v-col>
                            <v-col cols="3"></v-col>
                            <v-col cols="1"></v-col>

                            <template v-if="item.detail_sign_long_send_count_billing_count !== null">
                                <v-col cols="2"></v-col>
                                <v-col cols="3">
                                    <p class="text--primary sign_title">{{ signatureMethods.sign_long }}</p>
                                </v-col>
                                <v-col cols="2">
                                    <p class="text--primary text-right">{{ item.detail_sign_long_send_count_billing_count }}件</p>
                                </v-col>
                                <v-col cols="3">
                                    <p class="text--primary text-right">{{ toLocaleString(item.detail_sign_long_send_count_billing_amount) }}円</p>
                                </v-col>
                                <v-col cols="1"></v-col>
                            </template>

                            <template v-if="item.detail_sign_light_timestamp_send_count_billing_count !== null">
                                <v-col cols="2"></v-col>
                                <v-col cols="3">
                                    <p class="text--primary sign_title">{{ signatureMethods.sign_light_timestamp }}</p>
                                </v-col>
                                <v-col cols="2">
                                    <p class="text--primary text-right">{{ item.detail_sign_light_timestamp_send_count_billing_count }}件</p>
                                </v-col>
                                <v-col cols="3">
                                    <p class="text--primary text-right">{{ toLocaleString(item.detail_sign_light_timestamp_send_count_billing_amount) }}円</p>
                                </v-col>
                                <v-col cols="1"></v-col>
                            </template>

                            <template v-if="item.detail_sign_light_send_count_billing_count !== null">
                                <v-col cols="2"></v-col>
                                <v-col cols="3">
                                    <p class="text--primary sign_title">{{ signatureMethods.sign_light }}</p>
                                </v-col>
                                <v-col cols="2">
                                    <p class="text--primary text-right">{{ item.detail_sign_light_send_count_billing_count }}件</p>
                                </v-col>
                                <v-col cols="3">
                                    <p class="text--primary text-right">{{ toLocaleString(item.detail_sign_light_send_count_billing_amount) }}円</p>
                                </v-col>
                                <v-col cols="1"></v-col>
                            </template>

                            <template v-if="item.discount_amount > 0">
                                <v-col cols="2"></v-col>
                                <v-col cols="5">
                                    <p class="text--primary" style="color: red !important;">割引額</p>
                                </v-col>
                                <v-col cols="3">
                                    <p class="text--primary text-right" style="color: red !important;">-{{ item.discount_amount.toLocaleString() }}円</p>
                                </v-col>
                                <v-col cols="1"></v-col>
                            </template>

                            <v-col cols="2"></v-col>
                            <v-col cols="5" style="padding-right: 0;">
                                <p class="text--primary" style="border-bottom: solid 1px;">合計金額</p>
                            </v-col>
                            <v-col cols="4" style="padding-left: 0;">
                                <p class="text--primary text-right" style="border-bottom: solid 1px;">{{ item.billing_amount.toLocaleString() }} 円（税込）</u></p>
                            </v-col>
                        </v-row>
                    </v-row>
                </v-container>
            </v-card-text>
            
            <v-divider></v-divider>
            
            <v-card-actions class="justify-center grey lighten-4 pb-6">
                <v-btn min-width="150px" class="white--text" color="blue-grey lighten-1" large @click="handleDialog = false">
                    <slot name="cancel-btn"></slot>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { signatureMethodMixin } from '../../mixins/signatureMethodMixin.js';
export default {
    data() {
        return {};
    },
    props: {
        item: [],
        // ダイアログの開閉
        detailDialog: Boolean,
    },
    computed: {
        handleDialog: {
            get() {
                return this.detailDialog;
            },
            set(value) {
                // 親コンポーネントへの通知
                this.$emit('update:detailDialog', value);
            }
        },
    },
    mixins:[signatureMethodMixin],
    methods: {
        toLocaleString: function(value){
            if(value === undefined || value === null){
                return '';
            }
            return value.toLocaleString();
        }
    }
};
</script>

<style scoped lang="scss">
    .sign_title{
        margin-left: 2em;
        word-break: keep-all;
        min-width: 8em;
    }
</style>